var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 300,
        width: 400,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { rx: "2", height: "15", width: "380", y: "12.45313", x: "10" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "24", width: "380", y: "44.45313", x: "10" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "199", width: "62", y: "72.80448", x: "10" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "2",
          height: "198",
          width: "242.94596",
          y: "73.80447",
          x: "80.04054",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "58", width: "59", y: "73", x: "331.54054" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "2",
          height: "58",
          width: "59",
          y: "142.72973",
          x: "330.45946",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "58", width: "59", y: "214.88555", x: "331" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }